<template>
    <div>
        <kgr-member-offering-booking-data-provider
            :member-id="memberId"
            :callback="onMemberOfferingBookingsLoaded"
        >
            <div>
                <div class="kgr-row">
                    <kgr-checkbox
                        v-model="showCanceled"
                        class="kgr-checkbox--inline inline-checkbox"
                        :label="$t('Stornierte Termine anzeigen')"
                    />
                    <kgr-checkbox
                        v-model="showOnlyAbsent"
                        class="kgr-checkbox--inline inline-checkbox"
                        :label="$t('memberOfferingBooking.filter.showOnlyAbsent')"
                    />
                    <kgr-checkbox
                        v-model="showPastAppointments"
                        class="kgr-checkbox--inline inline-checkbox"
                        :label="$t('Vergangene Termine anzeigen')"
                    />
                </div>

                <kgr-accordion>
                    <div v-if="offerings.length > 0">
                        <div
                            v-for="offering in offerings"
                            :key="offering.id"
                        >
                            <div class="kgr-row"></div>
                            <kgr-accordion-item :title="getOfferingTitle(offering)">
                                <div class="kgr-row">
                                    <table class="kgr-table kgr-table--block kgr-table--striped data-table table-groups printable">
                                        <thead>
                                            <tr class="kgr-table__row">
                                                <th class="kgr-table__cell kgr-table__cell--headline">
                                                    {{ $t('Start') }}
                                                </th>
                                                <th class="kgr-table__cell kgr-table__cell--headline">
                                                    {{ $t('memberOfferingBooking.bookedAt') }}
                                                </th>
                                                <th class="kgr-table__cell kgr-table__cell--headline">
                                                    {{ $t('memberOfferingBooking.bookedByMember') }}
                                                </th>
                                                <th class="kgr-table__cell kgr-table__cell--headline">
                                                    {{ $t('storniert am') }}
                                                </th>
                                                <th class="kgr-table__cell kgr-table__cell--headline">
                                                    {{ $t('Rechnungsempfänger') }}
                                                </th>
                                                <th class="kgr-table__cell kgr-table__cell--headline">
                                                    {{ $t('booking.attendeeStatus') }}
                                                </th>
                                                <th class="kgr-table__cell kgr-table__cell--headline">
                                                    {{ $t('Aktion') }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="offeringBooking in getOfferingBookingsByOffering(offering)"
                                                :key="offeringBooking.id"
                                                class="kgr-table__row"
                                            >
                                                <td class="kgr-table__cell">
                                                    {{ offeringBooking.start }} {{ $t('Uhr') }}
                                                </td>
                                                <td class="kgr-table__cell">
                                                    {{ offeringBooking.bookedAt }} {{ $t('Uhr') }}
                                                </td>
                                                <td class="kgr-table__cell">
                                                    {{ offeringBooking.bookedByMember.fullName }}
                                                </td>
                                                <td class="kgr-table__cell">
                                                    <span v-if="offeringBooking.canceledAt">{{ offeringBooking.canceledAt }} {{ $t('Uhr') }}</span>
                                                    <span v-else-if="offeringBooking.canceledByClubAt">{{ offeringBooking.canceledByClubAt }} {{ $t('Uhr') }} ({{ $t('durch den Verein') }})</span>
                                                    <span v-else> - </span>
                                                </td>
                                                <td class="kgr-table__cell">
                                                    {{ offeringBooking.invoiceMember.fullName ?? '-' }}
                                                </td>
                                                <td class="kgr-table__cell">
                                                    {{ $t(`attendanceList.member.status.${offeringBooking.attendeeStatus}`) }}
                                                </td>
                                                <td class="kgr-table__cell">
                                                    <a
                                                        :href="getLinkByOfferingBooking(offeringBooking)"
                                                        class="kgr-link"
                                                    >{{ $t('zur Buchung') }}</a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </kgr-accordion-item>
                        </div>
                    </div>

                    <kgr-empty-data
                        v-if="offerings.length === 0"
                        :value="$t('Das Mitglied hat keine gebuchten Angebote.')"
                    />

                    <!-- BEGIN WAIT LIST ENTRIES -->
                    <div v-if="!showOnlyAbsent && waitListEntries.length > 0">
                        <div class="kgr-row"></div>
                        <kgr-accordion-item
                            :title="waitListTitle"
                            style="border: 1px solid var(--kgr-color-accent);"
                        >
                            <div class="kgr-row">
                                <table class="kgr-table kgr-table--block kgr-table--striped data-table table-groups printable">
                                    <thead>
                                        <tr class="kgr-table__row">
                                            <th class="kgr-table__cell kgr-table__cell--headline">
                                                {{ $t('Name') }}
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline">
                                                {{ $t('Start') }}
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline">
                                                {{ $t('Buchende/r') }}
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline">
                                                {{ $t('gebucht am') }}
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline">
                                                {{ $t('Status') }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="waitListEntry in waitListEntries"
                                            :key="waitListEntry.id"
                                            class="kgr-table__row"
                                        >
                                            <td class="kgr-table__cell">
                                                <a
                                                    :href="getLinkByWaitListEntry(waitListEntry)"
                                                    class="kgr-link"
                                                >{{ waitListEntry.appointmentTitle }}</a>
                                            </td>
                                            <td class="kgr-table__cell">
                                                {{ waitListEntry.appointmentStart }} {{ $t('Uhr') }}
                                            </td>
                                            <td class="kgr-table__cell">
                                                {{ waitListEntry.reservedByMember.fullName }}
                                            </td>
                                            <td class="kgr-table__cell">
                                                {{ waitListEntry.createdAt }} {{ $t('Uhr') }}
                                            </td>
                                            <td class="kgr-table__cell">
                                                {{ $t(`waitListEntry.status.${waitListEntry.status}`) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </kgr-accordion-item>
                    </div>
                </kgr-accordion>
            </div>
        </kgr-member-offering-booking-data-provider>
    </div>
</template>

<script>
import Accordion from '../../components/common/accordion/Accordion.vue';
import AccordionItem from '../../components/common/accordion/AccordionItem.vue';
import Checkbox from '../../components/common/form/checkbox/Checkbox.vue';
import EmptyData from '../../components/common/EmptyData.vue';
import Error from '../../js/model/Error';
import MemberOfferingBookingDataProvider from '../../components/data-provider/MemberOfferingBookingDataProvider.vue';
import WaitListRepository from '../../js/repository/WaitListRepository';

export default {
    components: {
        'kgr-member-offering-booking-data-provider': MemberOfferingBookingDataProvider,
        'kgr-accordion': Accordion,
        'kgr-accordion-item': AccordionItem,
        'kgr-empty-data': EmptyData,
        'kgr-checkbox': Checkbox,
    },
    props: {
        memberId: {
            type: Number,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            error: new Error(),
            offeringBookings: [],
            waitListEntries: [],
            showCanceled: false,
            showOnlyAbsent: false,
            showPastAppointments: true,
        };
    },
    computed: {
        filteredOfferingBookings() {
            let offeringBookings = this.offeringBookings;
            if (!this.showCanceled) {
                offeringBookings = offeringBookings.filter((offeringBooking) => !offeringBooking.isCanceled);
            }
            if (this.showOnlyAbsent) {
                offeringBookings = offeringBookings.filter((offeringBooking) => offeringBooking.attendeeStatus === 'absent');
            }
            if (!this.showPastAppointments) {
                offeringBookings = offeringBookings.filter((offeringBooking) => !offeringBooking.isStartInPast);
            }
            return offeringBookings;
        },
        offerings() {
            const offerings = new Map();
            this.filteredOfferingBookings.forEach((offeringBooking) => {
                const offering = offeringBooking.offering;
                if (!offerings.has(offering.id)) {
                    offerings.set(offering.id, offering);
                }
            });

            const arr = Array.from(offerings, ([, value]) => value);
            arr.sort((a, b) => a.title.localeCompare(b.title));
            return arr;
        },
        waitListTitle() {
            let title = this.$t('offering.waitlist.waitlist');
            title += ` (${this.waitListEntries.length})`;
            return title;
        },
    },
    mounted() {
        this.loadWaitListEntries();
    },
    methods: {
        onMemberOfferingBookingsLoaded(loadedOfferingBookings) {
            this.offeringBookings = loadedOfferingBookings;
        },
        getOfferingBookingsByOffering(offering) {
            const offeringId = offering.id;
            return this.filteredOfferingBookings.filter((offeringBooking) => offeringBooking.offering.id === offeringId);
        },
        getOfferingTitle(offering) {
            let title = '';
            if (offering.customId) {
                title += `${offering.customId} - `;
            }
            title += `${offering.title} (${this.getOfferingBookingsByOffering(offering).length})`;
            return title;
        },
        getLinkByOfferingBooking(offeringBooking) {
            if (offeringBooking.offering.offeringCategory.name === 'course') {
                return `/backend/clubs/${this.clubId}/course-offerings/${offeringBooking.offering.id}/view`;
            } else if (offeringBooking.offering.offeringCategory.name === 'training') {
                return `/backend/clubs/${this.clubId}/training-offerings/${offeringBooking.offering.id}/view`;
            } else if (offeringBooking.offering.offeringCategory.name === 'exam') {
                return `/backend/clubs/${this.clubId}/exam-offerings/${offeringBooking.offering.id}/view`;
            } else {
                return `/backend/clubs/${this.clubId}/generic-offerings/${offeringBooking.offering.id}/view`;
            }
        },
        getLinkByWaitListEntry(waitListEntry) {
            if (waitListEntry.isCourse) {
                return `/backend/clubs/${this.clubId}/course-offerings/${waitListEntry.offeringId}/view`;
            }

            return `/backend/clubs/${this.clubId}/generic-offerings/${waitListEntry.offeringId}/view`;
        },
        loadWaitListEntries() {
            WaitListRepository.findByMemberId(this.memberId)
                .then((waitListEntries) => this.waitListEntries = waitListEntries)
                .catch(() => this.$notify.error('error.loadingData'));
        },
    },

};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
